import ParserOriginal from 'html-react-parser'

/* reexported with a TS type because original module has default export */
export const Parser = ParserOriginal as unknown as typeof ParserOriginal.default
